import axios from "axios";

function getHeaders() {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
}

export const getPartialInvoiceCountReport = async (groupBy) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/dashboard/api/invoice-report/invoice_partial_count_report/?group_by=${groupBy}`,
      getHeaders()
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        "Failed to fetch partial invoice count report"
    );
  }
};
